import TreatmentTimeHome from './components/TreatmentTimeHome';
import './App.css';

function App() {
  return (
    <div className="App">
      <TreatmentTimeHome />
    </div>
  );
}

export default App;
